import clsx from "clsx"
export default function Minus({ className = '' }) {
  return (

    <svg className={clsx(className, 'w-[1.0625rem] h-auto')} width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className="lg:stroke-2" d="M16.5 1.5L-1.78814e-07 1.5" stroke="#38362D" strokeWidth="1.39493" />
    </svg>

  )
}
